import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { Product } from '../../models/product.model';
import { ToastService } from '../../toast.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-vendor-product-management',
  templateUrl: './vendor-product-management.component.html',
  styleUrls: ['./vendor-product-management.component.scss']
})
export class VendorProductManagementComponent implements OnInit {
  products: Product[] = [];
  editingProduct: any = null; // holds product being added/edited
  environment = environment;

  constructor(private productService: ProductService, private toast: ToastService, private router: Router) { }

  ngOnInit(): void {
    this.loadProducts();
  }

  goToAddProduct() {
    this.router.navigate(['admin/CreateProduct']);
  }

  loadProducts(): void {
    this.productService.getProductsByVendor().subscribe({
      next: (res) => {
        this.products = res
      },
      error: (err) => {
        console.error('Error loading products:', err)
        this.toast.show(err.error?.message || 'Something went wrong', 'error');
      }
    });
  }

  add(product: Product): void {
    this.productService.addProduct(product).subscribe({
      next: () => {
        this.loadProducts();
        this.editingProduct = null;
      },
      error: (err) => {
        console.error('Error creating product:', err)
        this.toast.show(err.error?.message || 'Something went wrong', 'error');
      }
    });
  }

  update(id: number, product: Product): void {
    this.productService.updateProductById(id, product).subscribe({
      next: () => {
        this.loadProducts();
        this.editingProduct = null;
      },
      error: (err) => {
        console.error('Error updating product:', err)
        this.toast.show(err.error?.message || 'Something went wrong', 'error');
      }
    });
  }

  edit(product: Product): void {
    // Clone the object safely
    this.editingProduct = { ...product };
  }

  remove(id: number): void {
    if (!confirm('Are you sure you want to delete this product?')) return;
    this.productService.deleteProductById(id).subscribe({
      next: () => this.loadProducts(),
      error: (err) => {
        console.error('Error deleting product:', err)
        this.toast.show(err.error?.message || 'Something went wrong', 'error');
      }
    });
  }
}
